export default "__VITE_ASSET__C0bhC1ci__"